// The FTR mark: a tile split 60/40 (the Section 1256 split), with the letters in Inter Tight Bold, outlined.
// apps/web/public/favicon.svg is the same drawing; keep the two in step.
const LETTERS = [
  {
    x: 8.895,
    d: "M89.999 0V1490H1091.801V1213.798H426.802V822.6H1026.601V551.998H426.802V0Z",
  },
  {
    x: 22.462,
    d: "M37.4 1213.798V1490H1278.602V1213.798H824.602V0H492V1213.798Z",
  },
  {
    x: 38.252,
    d: "M89.999 0V1490H690.601Q859.301 1490 979.901 1429.8Q1100.501 1369.6 1165.351 1259.1Q1230.202 1148.6 1230.202 998.399Q1230.202 847.099 1164.451 739.499Q1098.701 631.899 975.651 575.449Q852.601 518.999 681.401 518.999H290.801V787.401H622.2Q708.599 787.401 766.199 810.501Q823.799 833.6 852.599 880.25Q881.399 926.9 881.399 998.399Q881.399 1070.199 852.449 1118.299Q823.499 1166.398 765.899 1190.798Q708.299 1215.198 621.6 1215.198H426.802V0ZM911.599 0 548.799 679.8H911.001L1282.601 0Z",
  },
];

export function Logo({ size = 28, outline = false }: { size?: number; outline?: boolean }) {
  return (
    <svg className="logo" width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#0f3d2a" />
      <path className="logo-split" d="M38.4 0H50A14 14 0 0 1 64 14V50A14 14 0 0 1 50 64H38.4Z" fill="#1fa463" />
      <g fill="#f2f7f3">
        {LETTERS.map((l) => (
          <g key={l.x} className="logo-letter">
            <path d={l.d} transform={`translate(${l.x} 44) scale(0.01228 -0.01228)`} />
          </g>
        ))}
      </g>
      {outline && <rect x="0.75" y="0.75" width="62.5" height="62.5" rx="13.25" fill="none" stroke="#ffffff" strokeOpacity="0.22" strokeWidth="1.5" />}
    </svg>
  );
}
